import React, { useState, useEffect } from "react";
import Gallery from "./Gallery";
import Login from "./Login";
import Hero from "./Hero";

const App = () => {
  const [authenticated, setAuthenticated] = useState(false);

  const handleLoginSuccess = () => {
    setAuthenticated(true);
    document.cookie = "authenticated=true; path=/"; // Guardar cookie de autenticación
  };

  const checkAuthentication = () => {
    const cookies = document.cookie.split("; ");
    const authCookie = cookies.find((cookie) =>
      cookie.startsWith("authenticated=")
    );
    return authCookie && authCookie.split("=")[1] === "true";
  };

  // Verificar si el usuario ya está autenticado al cargar la página
  useEffect(() => {
    if (checkAuthentication()) {
      setAuthenticated(true);
    }
  }, []);

  return (
    <div>
      {authenticated ? (
        <>
          <Hero />
          <div id="gallery">
            <Gallery />
          </div>
        </>
      ) : (
        <Login onLoginSuccess={handleLoginSuccess} />
      )}
    </div>
  );
};

export default App;
